import { Box, Icon, Typography } from '@mui/material'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import EDHeader from '../components/EDHeader'
import EDTabs from '../components/EDTabs'

const EvaluationDetails = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state.item

  const handleBackAppraisalCycle = () => {
    navigate('/app/appraisal-cycle', {
      state: { mainAppraisalTabsValue: location.state.mainAppraisalTabsValue },
    })
  }

  const handleBack = () => {
    navigate(`/app/appraisal-cycle/details/${location.state.id}`, {
      state: { ...location.state, initialTabsValue: 1 },
    })
  }

  return (
    <DashboardContainer headerTitle="Appraisal">
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center">
          <Typography
            onClick={handleBackAppraisalCycle}
            sx={{ cursor: 'pointer' }}
            color="alternate.main"
          >
            Appraisal
          </Typography>
          <Icon sx={{ fontSize: 20, color: 'light-gray-text.main' }}>chevron_right</Icon>
          <Typography
            onClick={handleBack}
            sx={{ cursor: 'pointer' }}
            color="alternate.main"
            textTransform="capitalize"
          >
            {location.state.cycleName}
          </Typography>
          <Icon sx={{ fontSize: 20, color: 'light-gray-text.main' }}>chevron_right</Icon>
          <Typography color="light-gray-text.main">{state.title}</Typography>
        </Box>
        <EDHeader
          title={state.title}
          icon="leaderboard"
          progress={(state.submission_complete / state.submission_total) * 100}
          result={state.submission_complete + '/' + state.submission_total}
        />
        <EDTabs
          appraisalStatus={location.state.status_name}
          title={state.title}
          description={state.description}
          formId={state.form_id}
          form={state.form_name}
          dept={state.participant_departments}
          rule={state.participant_match_type_name}
          letRevieweeView={state.is_revieweeView}
          letReviewerView={state.is_reviewerView}
          letFeedback={state.has_feedback}
          letAnonymous={state.is_anonymous}
          totalParticipants={state.submission_total}
        />
      </Box>
    </DashboardContainer>
  )
}

export default EvaluationDetails
